"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_PROFILE_WEBSITE_LENGTH = exports.MAX_PROFILE_DESCRIPTION_LENGTH = exports.MAX_PROFILE_FULL_NAME_LENGTH = exports.MAX_COMMENT_LENGTH = exports.MAX_EXERCISE_TITLE_LENGTH = exports.MAX_ROUTINE_EXERCISE_NOTES_LENGTH = exports.MAX_ROUTINE_TITLE_LENGTH = exports.MAX_WORKOUT_EXERCISE_NOTES_LENGTH = exports.MAX_WORKOUT_DESCRIPTION_LENGTH = exports.MAX_WORKOUT_TITLE_LENGTH = void 0;
exports.MAX_WORKOUT_TITLE_LENGTH = 100;
exports.MAX_WORKOUT_DESCRIPTION_LENGTH = 2000;
exports.MAX_WORKOUT_EXERCISE_NOTES_LENGTH = 2000;
exports.MAX_ROUTINE_TITLE_LENGTH = 100;
exports.MAX_ROUTINE_EXERCISE_NOTES_LENGTH = 2000;
exports.MAX_EXERCISE_TITLE_LENGTH = 100;
exports.MAX_COMMENT_LENGTH = 250;
exports.MAX_PROFILE_FULL_NAME_LENGTH = 100;
exports.MAX_PROFILE_DESCRIPTION_LENGTH = 200;
exports.MAX_PROFILE_WEBSITE_LENGTH = 100;
